import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
    selector: 'app-default-filter',
    templateUrl: './default-filter.component.html',
    styleUrls: ['./default-filter.component.scss'],
    standalone: false
})
export class DefaultFilterComponent implements OnInit {
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

  @Input() defaultFilterOptions: any;

  @Input() selectedDefaultFilter: any;

  @Output() changed = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  defaultFilterChanged(option): void {
    this.changed.emit(option);
  }
}
